import hook from './hook.ts'
const appHook = hook()
export default appHook;